import type { TabPanelProps } from "@mui/base";
import type { FunctionComponent } from "react";

import { Container } from "./styles";
type Props = {
  className?: string;
  index?: number;
} & TabPanelProps;

export const OlympicTodayHighlightsTabPanel: FunctionComponent<Props> = ({
  children,
  index,
  value,
  ...other
}) => (
  <Container hidden={value !== index} role="tabpanel" {...other}>
    {value === index && children}
  </Container>
);

OlympicTodayHighlightsTabPanel.displayName = "OlympicTodayHighlightsTabPanel";
